module.exports = __webpack_public_path__ + "img/icon_alert_black.9b87ec33.svg";